import React, { Dispatch, SetStateAction, useContext, useEffect } from "react";
// import { Button } from "primereact/button";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import useDarkTheme from "app/hooks/useDarkTheme";
import { getSessionStore, setSessionStore } from "app/utils/sessionStore";
import { TRIGGER_SAVE_THEME_SETTINGS } from "app/redux/features/agent-branding";
import { useDispatch } from "react-redux";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";
import PrimeReact from "primereact/api";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import { ReactComponent as LightLogo } from "app/assets/svg/light-mode.svg";
import { ReactComponent as DarkLogo } from "app/assets/svg/dark-mode.svg";

function DarkModeSelection() {
  const { branding = "" } = getSessionStore("lookUpResponse") ?? {};
  const { primaryColor = "" } = branding ?? {};
  const { isOpen } = useContext(ContactProfileDetailsContext);
  const { isDarkMode, setIsDarkMode } = useContext(ThemeContext);
  const [, setTheme]: [string, Dispatch<SetStateAction<string>>] = useDarkTheme();
  const dispatch = useDispatch();
  useEffect(() => {
    setTheme(isDarkMode ? "dark" : "light");
    setSessionStore("globalTheme", isDarkMode ? "dark" : "light");
    const themeSelectionSlider = document.querySelector(
      ".theme-switch-with-icons .p-inputswitch-slider",
    ) as HTMLElement;
    if (themeSelectionSlider) {
      const sliderColor = isDarkMode ? primaryColor || "#002446" : "#ffffff";
      themeSelectionSlider.style.backgroundColor = sliderColor;
    }
  }, [isDarkMode, primaryColor, setTheme]);
  const onThemeSelect = (value?: boolean) => {
    const newTheme = value ? "dark" : "light";
    const oldTheme = newTheme === "light" ? "dark" : "light";
    setSessionStore("globalTheme", value ? "dark" : "light");
    PrimeReact?.changeTheme?.(`lara-${oldTheme}-blue`, `lara-${newTheme}-blue`, "app-theme", () => {
      const allThemeLinks = document.querySelectorAll("link#app-theme");
      if (allThemeLinks.length > 1) {
        for (let i = 1; i < allThemeLinks.length; i++) {
          allThemeLinks[i].remove();
        }
      }
    });
    dispatch({
      type: TRIGGER_SAVE_THEME_SETTINGS,
      payload: {
        address: "saveThemeSettings",
        body: { theme: value ? "dark" : "light" },
      },
    });
  };

  // useEffect(() => {
  //   appTheme === "dark" && setIsDarkMode(true);
  // }, [appTheme]);

  return (
    <>
      <style>
        {`
          .theme-switch-with-icons {
            width: 60px !important;
            height: 28px !important;
          }
          .theme-switch-with-icons .p-inputswitch-slider {
            width: 60px !important;
            height: 28px !important;
            border-radius: 14px !important;
          }
          .theme-switch-with-icons .p-inputswitch-slider:before {
            width: 20px !important;
            height: 20px !important;
            left: 4px !important;
            margin-top: -10px !important;
            background: #e9ecef !important;
          }
          .theme-switch-with-icons.p-inputswitch-checked .p-inputswitch-slider:before {
            transform: translateX(32px) !important;
            background: #ffffff !important;
          }
        `}
      </style>
      <div className="full p-2 mt-2 relative group">
        <div
          className={`flex  gap-2 items-center justify-center ${isOpen ? "flex-row" : "flex-col"} `}
        >
          <div className="relative inline-block" style={{ width: "60px", height: "28px" }}>
            <InputSwitch
              tooltip="Mode"
              tooltipOptions={{
                className: "tooltip-wrapper",
              }}
              checked={isDarkMode}
              onChange={(e: InputSwitchChangeEvent) => {
                setIsDarkMode(e.value ?? false);
                onThemeSelect(e.value as boolean);
              }}
              className="theme-switch-with-icons"
            />
            <LightLogo
              style={{
                width: "14px",
                height: "14px",
                color: isDarkMode ? "#adb5bd" : "#495057",
                position: "absolute",
                left: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                zIndex: 2,
              }}
            />
            <DarkLogo
              style={{
                width: "14px",
                height: "14px",
                color: isDarkMode ? "#495057" : "#adb5bd",
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                zIndex: 2,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DarkModeSelection;
